module.exports = __webpack_public_path__ + "media/images/Timbits-Soccer-GIF-V2.1-496e957e.gif";